$(document).ready(function () {
    $(document).on('click', '[data-filter]', function (e) {

        const obj = (typeof $(this).data('filter') !== 'undefined') ? $(this).data('filter').toString() : false,
            filterBy = (typeof $(this).data('filter-by') !== 'undefined') ? $(this).data('filter-by').toString() : false,
            filterValue = (typeof $(this).data('filter-value') !== 'undefined') ? $(this).data('filter-value').toString() : false,
            filterClass = (typeof $(this).data('filter-class') !== 'undefined') ? $(this).data('filter-class').toString() : 'active';

        e.preventDefault();

        if (!obj || !filterBy || (filterClass && $(this).hasClass(filterClass))) return;
        if (filterValue === "")
            $(obj).children().show();
        else
            $(obj).children().hide().filter('[' + filterBy + '="' + filterValue + '"]').show();

    });
});